import config from '../config'

class Search {
    constructor() {
        this.body = document.body
        this.toggles = document.querySelectorAll('.search-toggle')
        this.overlay = document.getElementById('search-overlay')
        this.form = document.getElementById('search-form')
        this.input = document.getElementById('search-input')
        this.posts = {
            container: document.getElementById('search-posts-container'),
            wrapper: document.getElementById('search-posts-wrapper'),
        }
        this.immigrationLaw = {
            container: document.getElementById(
                'search-immigration-law-container'
            ),
            wrapper: document.getElementById('search-immigration-law-wrapper'),
        }
        this.familyLaw = {
            container: document.getElementById('search-family-law-container'),
            wrapper: document.getElementById('search-family-law-wrapper'),
        }

        this.bindEventListeners()
    }

    bindEventListeners() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.closeSearchOverlay()
        })

        this.toggles.forEach((searchToggle) =>
            searchToggle.addEventListener('click', (e) =>
                this.toggleSearchOverlay(e)
            )
        )

        this.form.addEventListener('submit', (e) => this.handleSubmit(e))
    }

    closeSearchOverlay(e) {
        if (this.body.classList.contains('search-active'))
            this.body.classList.remove('search-active')
    }

    toggleSearchOverlay(e) {
        e.preventDefault()
        this.body.classList.toggle('search-active')

        if (this.body.classList.contains('search-active')) this.input.focus()
    }

    handleSubmit(e) {
        e.preventDefault()

        const formData = new FormData()
        formData.append('action', 'reiss_edwards_submitSearchForm')
        formData.append('security', config.security.submitSearchForm)
        formData.append('query', this.input.value)

        const xhr = new XMLHttpRequest()
        xhr.open('POST', config.ajaxUrl, true)

        this.immigrationLaw.container.classList.remove('active')
        this.familyLaw.container.classList.remove('active')
        this.posts.container.classList.remove('active')
        this.overlay.classList.add('loading')

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText)

                    if (response.status === 'success') {
                        if (response.html.immigrationLaw.length > 0)
                            this.setImmigrationLaw(response.html.immigrationLaw)
                        if (response.html.familyLaw.length > 0)
                            this.setFamilyLaw(response.html.familyLaw)
                        if (response.html.posts.length > 0)
                            this.setPosts(response.html.posts)
                    } else {
                        // Error
                    }
                } else {
                    // Error
                }
            }

            setTimeout(() => {
                this.overlay.classList.remove('loading')
            }, 2000)
        }

        xhr.onerror = () => {
            this.overlay.classList.remove('loading')
        }

        xhr.send(formData)
    }

    setImmigrationLaw(immigrationLawHtml = '') {
        this.immigrationLaw.wrapper.innerHTML = immigrationLawHtml
        this.immigrationLaw.container.classList.add('active')
    }

    setFamilyLaw(familyLawHtml = '') {
        this.familyLaw.wrapper.innerHTML = familyLawHtml
        this.familyLaw.container.classList.add('active')
    }

    setPosts(postHtml = '') {
        this.posts.wrapper.innerHTML = postHtml
        this.posts.container.classList.add('active')
    }
}

export default Search
